var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C10 7.76145 7.76145 10 5 10C2.23858 10 0 7.76145 0 5C0 2.23858 2.23858 0 5 0C7.76145 0 10 2.23858 10 5ZM5.41667 2.16926C5.41667 1.93914 5.23011 1.75259 5 1.75259C4.76989 1.75259 4.58333 1.93914 4.58333 2.16926V5.18244V5.40106L4.76317 5.52528L6.79945 6.93183C6.98878 7.06261 7.24828 7.01511 7.37911 6.82578C7.50989 6.63644 7.46239 6.37695 7.27306 6.24617L5.41667 4.96383V2.16926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.7b6545c01633a9f54d118c7edbaa50c5.svg";
export { ForwardRef as ReactComponent };